import { Message, MessageAuthor } from '../../../models/assistant';
import { Bubble } from './message-bubble';

interface ToBubblesParams {
  /** What the backend has stored. */
  messages: Message[];
  /** A message sent but not yet answered, shown right away. */
  pendingContent: string | null;
  /** What the assistant has written of its answer so far. */
  answerText: string;
  /** Said after a stored question of the user that has no answer, when none is on its way. */
  errorText: string;
}

const userBubble = (text: string): Bubble => ({ from: 'user', text });

const storedBubble = (message: Message): Bubble => ({
  from: message.author === MessageAuthor.USER ? 'user' : 'assistant',
  text: message.content,
});

export default function toBubbles({
  messages,
  pendingContent,
  answerText,
  errorText,
}: ToBubblesParams): Bubble[] {
  const bubbles = messages.map(storedBubble);
  const last = messages[messages.length - 1];
  const lastIsQuestion = last?.author === MessageAuthor.USER;
  const isAnswering = pendingContent !== null || answerText !== '';

  if (lastIsQuestion && !isAnswering) {
    bubbles.push({ from: 'assistant', text: errorText, isError: true });
  }

  // The backend stores the question as soon as it gets it, so a reload during the wait already has it.
  if (pendingContent && !(lastIsQuestion && last.content === pendingContent)) {
    bubbles.push(userBubble(pendingContent));
  }

  if (answerText) {
    bubbles.push({ from: 'assistant', text: answerText });
  }

  return bubbles;
}
